import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useBrandContext } from '../../../context/BrandContext';
import { useHeaderContext } from '../../../context/HeaderContext';
import { useToast } from '../../../context/ToastModalContext';
import { getOrderData } from '../../../services/extractService';
import { ReactComponent as LoaderSecondary } from '../../../assets/SpinnerBlack.svg';
import { IOrderData } from '../../../shared/models/orderData/orderData';
import {
  formatCurrency,
  formatDateWalletHistory,
  getTypeCard,
} from '../../../utils/format';
import './CreditExtract.css';

const CreditExtract: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState<IOrderData>();
  const [orderState, setOrderState] = useState<string>('');
  const { id } = useParams();
  const brandContext = useBrandContext();
  const { setHeaderConfig } = useHeaderContext();
  // const routePaths = location.pathname.split('/');

  //toast
  const { showToast } = useToast();

  const getCreditExtractData = async (id: string) => {
    if (id) {
      try {
        const response = await getOrderData(id);
        setIsError(false);
        const orderPaymentMethodData = response.orderPaymentMethodData
          ? JSON.parse(response.orderPaymentMethodData)
          : response;
        setOrderState(response.orderState);
        const orderDataValue: IOrderData = {
          amount: formatCurrency(response?.orderAmount),
          cardInfo: orderPaymentMethodData.description
            ? orderPaymentMethodData.description
            : '',
          date: formatDateWalletHistory(new Date(response.orderUpdated)),
          authorizationCod: response.orderInvoiceId
            ? response.orderInvoiceId
            : response.orderId,
          item_type: orderPaymentMethodData.item_type,
          orderState: orderPaymentMethodData.orderState,
        };
        setOrderData(orderDataValue);
        setIsLoading(false);
      } catch (er) {
        setIsLoading(false);
        setIsError(true);
        showToast({
          title: 'Falha',
          messageModal:
            'Falha ao carregar Extrato de Adição. Por favor, tente novamente',
          textEnterButton: 'Tentar novamente',
          allowButtonClosed: true,
          handleEnterButton: () => getCreditExtractData(id),
          closeButtonText: 'Fechar',
        });
        console.log(er);
      }
    }
  };
  useEffect(() => {
    setIsLoading(true);
    if (id) {
      getCreditExtractData(id);
    }
  }, [id]);

  const backNavigation = useCallback(() => {
    navigate(`/${brandContext.brandName}/extract`);
  }, [brandContext.brandName, navigate]);

  useEffect(() => {
    setHeaderConfig({
      headerText: 'Adicionou',
      backNavigation: backNavigation,
    });
    return () => setHeaderConfig({});
  }, [backNavigation, navigate, setHeaderConfig]);

  return (
    <>
      {orderData && !isLoading ? (
        <div className='credit-extract-container'>
          <span
            className='credit-extract-ammount'
            style={
              orderState === 'canceled' || orderState === 'refunded'
                ? { textDecoration: 'line-through' }
                : {}
            }
          >
            {orderData?.amount}
          </span>
          <span className='credit-extract-payment-card'>
            {orderData?.item_type !== 'pix' && getTypeCard(orderData?.item_type)
              ? ` ${orderData?.cardInfo} • Cartão de ${getTypeCard(
                  orderData?.item_type
                )?.toLocaleLowerCase()}`
              : `${
                  getTypeCard(orderData?.item_type)
                    ? getTypeCard(orderData?.item_type)
                    : ''
                }`}
            {orderState === 'refunded'
              ? ' - Valor estornado'
              : orderState === 'canceled'
              ? ' - Cancelado'
              : ''}
          </span>
          <span className='credit-extract-date-time'>{orderData?.date}</span>
          <div className='credit-extract-spott-info-container'>
            <span className='credit-extract-spott-info-ltda'>
              Spott Tecnologia LTDA
            </span>
            <span className='credit-extract-spott-info-cnpj'>
              CNPJ 045.057.615/0001-92
            </span>
            <span className='credit-extract-spott-info-transaction'>
              Transação #{orderData?.authorizationCod}
            </span>
          </div>
        </div>
      ) : !isLoading && !isError ? (
        <span>Não há transações</span>
      ) : (
        !isError && <LoaderSecondary />
      )}
    </>
  );
};

export default CreditExtract;
